import React, {useState} from "react";
import ReactDOM from "react-dom/client";
import Navbar from './src/pages/common/Navbar/navbar.js';
import HomePage from "./src/pages/HomePage/homepage.js";
import ImageGenerator from './src/pages/ImageGenerator/imageGenerator.js';
import HistoryPage from "./src/pages/HistoryPage/historyPage.js";
import PointsContext from "./src/context/pointsContext.js";

import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import HistoryInformationPage from "./src/pages/HistoryInformationPage/historyInformationPage.js";
import Signup from "./src/pages/signup/signup.js";

const parent = document.getElementById("root");
const root = ReactDOM.createRoot(parent);
const PORT = process.env.PORT || 1234
const App = ()=>{
    const [userPoints, setUserPoints] = useState(8);
    const [isLoggedIn, setIsLoggedIn] = useState(()=>{
        if(localStorage.getItem('authorization')){
            return true;
        }
        else return false;
    });
    const login = () => {
        setIsLoggedIn(true);
    }
    const logout = () => {
        localStorage.removeItem('authorization');
        setIsLoggedIn(false);
    }

    const router = createBrowserRouter([
        {
            path: "/",
            element: <HomePage/>
        },
        {
            path: "/image-generator",
            element: (userPoints - 1 >= 0)? <ImageGenerator/> : isLoggedIn? <ImageGenerator/> : <Navigate to='/' />
        },
        {
            path: '/history',
            element: <HistoryPage/>
        },
        {
            path: '/history/:historyId',
            element: <HistoryInformationPage/>
        },
        {
            path: '/signup',
            element: <Signup/>
        },
    ]);

    return (        
        <PointsContext.Provider value={{
            userPoints: userPoints, 
            setUserPoints: setUserPoints,
            isLoggedIn: isLoggedIn,
            login,
            logout,
        }}>
            <RouterProvider router={router} />
        </PointsContext.Provider>
    );
}

root.render(<App/>);
